import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserState } from './UserStateProvider';
import { checkUser, updateUserLatestReleaseVersion, getUserLatestViewedRelease } from '../../data/dataApi';

const RouteAuthorizer = ({ element, requireAuth, capability, updateUserReleaseVersion }) => {
    const [loading, setLoading] = useState(true);

    const { appVersion, setUser, userCapabilities, userCapabilitiesRetrieved, setUserLatestViewedRelease } = useUserState();

    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            const userResponse = await checkUser();
            setUser(userResponse);

            if(userResponse.id && !requireAuth || (userCapabilitiesRetrieved && capability && !userCapabilities.includes(capability))) {
                navigate("/home", { replace: true });
            } else if(!userResponse.id && requireAuth) {
                navigate("/", { replace: true });
            }

            if(updateUserReleaseVersion) {
                const userLatestViewedReleaseResponse = await getUserLatestViewedRelease();

                if(userLatestViewedReleaseResponse.data.latest_viewed_release !== appVersion) {
                    const response = await updateUserLatestReleaseVersion(appVersion);

                    if(response.success) {
                        setUserLatestViewedRelease(appVersion);
                    }
                }   
            }

            setLoading(false);
        })();
    }, [navigate, userCapabilitiesRetrieved]);

    if(loading || !userCapabilitiesRetrieved) {
        return <></>;
    } else {
        return element;
    }
};

export default RouteAuthorizer;
